import React, { useEffect, useState } from "react";
import HeaderMenu from "../../_components/HeaderMenu/HeaderSection";
import "../../_styles/localStyles/typeOfService.css";
import { useTranslation } from "react-i18next";
import { Button } from "../../_components/Button/Button";
import IMAGES from "../../_assets/images/index";
import { Footer } from "../../_components/footer/Footer";
import ProgressBar from "../../_components/progressbar/ProgressBar";
import RadioButton from "../../_components/radioButton/radioButton";
import { checkoutModel } from "../../_redux/Models/checkout.model";
import { useDispatch, useSelector } from "react-redux";
import { checkoutStore, plumbingStore } from "../../_redux/actions";
import {
  calculateTotalCost,
  formatPrice,
} from "../../services/utils/utilFunctions";
import { plumbingModel } from "../../_redux/Models/plumbing.model";
import { getServicePriceDetails } from "../../services/api/category.api.service";
import { useHistory } from "react-router-dom";
import { useRecoilState } from "recoil";
import { selectedContractorAtom } from "../../recoil/atoms/contractorAtom";

export const PlumbingHowUrgentService = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedContractorId] = useRecoilState(selectedContractorAtom);

  const [price, setPrice] = useState(calculateTotalCost(plumbingModel.costFor)); // To keep the total price in state
  const [option, setOption] = useState("");

  const checkoutModelAs = useSelector((state) =>
    state.checkout && state.checkout.payload
      ? state.checkout.payload
      : checkoutModel
  );
  const state = useSelector((state) =>
    state.buttonReducer && state.buttonReducer.plumbingPayload
      ? state.buttonReducer.plumbingPayload
      : plumbingModel
  );

  const [pricing, setPricing] = useState([]);

  useEffect(() => {
    let mounted = true;
    const selectedService = checkoutModelAs.selectedServiceDetails;
    if (mounted === true && selectedService._id && selectedService.categoryId) {
      getServicePriceDetails(
        selectedService.categoryId,
        selectedService._id
      ).then((response) => {
        if (mounted && response.status === 200 && response.data) {
          console.log(response.data.details);
          checkoutModelAs.priceDetails = response.data.details;
          dispatch(checkoutStore(checkoutModelAs));
          if (response.data?.details?.typeOfService[0]?.options) {
            const options = response.data.details.typeOfService[0].options.map(
              (op) => {
                return {
                  text: t(`plumbing.${op.key}`),
                  value: op.key,
                  price: op.price,
                };
              }
            );
            setPricing(options);
          }
        }
      });
    }
    return () => (mounted = false);
  }, [checkoutModelAs, dispatch, t]);

  const onSave = (text, prc) => {
    state.howUrgent = text;
    state.costFor.service = prc;
    checkoutModelAs.totalCost = prc;
    dispatch(checkoutStore(checkoutModelAs));
    dispatch(plumbingStore(state));
    history.push(
      `/contractor-portfolio/${selectedContractorId}/plumbing/comments/3`
    );
  };

  return (
    <div class="insideWrp">
      <div style={{ padding: "0px 20px 20px 20px" }}>
        <div>
          <div className="paint_flex_with_left">
            <label className="paint_header">{"How urgent is it?"}</label>
          </div>
          <div className="padding10"></div>

          {pricing.map((item) => (
            <div
              onClick={() => {
                setOption(item.text);
                setPrice(item.price);
                onSave(item?.text, item?.price);
              }}
              className={`floor-selection-radio ${
                option === item?.text ? "selected" : ""
              }`}
            >
              <div
                className="width100"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <label className="paintdiv_txt">{item.text}</label>
                <div
                  className="paint_arrowFloat"
                  style={{
                    width: "130px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <img src={IMAGES.other.green_plus} alt="" />
                    <label className="paintdiv_txt">
                      {`$${formatPrice(item.price)}`}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className="padding10"></div>
          <label>
            This includes an onsite diagnose, the repair itself will be
            estimated on site.
          </label>
        </div>
      </div>
    </div>
  );
};
